import { createSelector } from '@ngrx/store'
import { RosterTableViewModel } from '@view/pages/roster-page/roster-table.view'
import { selectSelectedRosterTab } from './roster-page.selector'
import { selectIsPreviewMod } from './roster-view.selector'

export const selectTableDisplayedColumns = createSelector(
  selectIsPreviewMod,
  selectSelectedRosterTab,
  RosterTableViewModel.getTableDisplayedColumns
)